var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.062 17.8744V13.7493C13.062 13.567 12.9896 13.3921 12.8606 13.2632C12.7317 13.1342 12.5568 13.0618 12.3745 13.0618H9.6245C9.44216 13.0618 9.26729 13.1342 9.13836 13.2632C9.00943 13.3921 8.937 13.567 8.937 13.7493V17.8744C8.937 18.0567 8.86458 18.2316 8.73566 18.3605C8.60675 18.4894 8.4319 18.5619 8.24958 18.5619L4.12509 18.5624C4.03479 18.5624 3.94539 18.5447 3.86196 18.5101C3.77854 18.4756 3.70274 18.4249 3.63889 18.3611C3.57504 18.2973 3.5244 18.2215 3.48984 18.138C3.45529 18.0546 3.4375 17.9652 3.4375 17.8749V9.92911C3.4375 9.83333 3.45751 9.7386 3.49626 9.65101C3.535 9.56341 3.59163 9.48488 3.66249 9.42044L10.537 3.1698C10.6636 3.05473 10.8285 2.99097 10.9995 2.99097C11.1705 2.99096 11.3354 3.05471 11.462 3.16977L18.3375 9.42044C18.4084 9.48488 18.465 9.56341 18.5037 9.65101C18.5425 9.73862 18.5625 9.83335 18.5625 9.92914V17.8749C18.5625 17.9652 18.5447 18.0546 18.5102 18.138C18.4756 18.2215 18.425 18.2973 18.3611 18.3611C18.2973 18.4249 18.2215 18.4756 18.138 18.5101C18.0546 18.5447 17.9652 18.5624 17.8749 18.5624L13.7494 18.5619C13.5671 18.5619 13.3922 18.4894 13.2633 18.3605C13.1344 18.2316 13.062 18.0567 13.062 17.8744V17.8744Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.3212c1f8a9414c28ae3286d7b47a8440.svg";
export { ForwardRef as ReactComponent };